var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Button, { ButtonVariants } from '../Button';
var ModalFooter = function (_a) {
    var name = _a.name, children = _a.children, staticSize = _a.staticSize, primaryButtonProps = _a.primaryButtonProps, secondaryButtonProps = _a.secondaryButtonProps, className = _a.className, htmlProps = __rest(_a, ["name", "children", "staticSize", "primaryButtonProps", "secondaryButtonProps", "className"]);
    var PrimaryButton = secondaryButtonProps ? Button : CenteredButton;
    return (_jsxs(Footer, __assign({ className: className }, htmlProps, { children: [secondaryButtonProps && (_jsx(SecondaryButton, __assign({ staticSize: staticSize, variant: ButtonVariants.TEXT, type: "button" }, ((secondaryButtonProps === null || secondaryButtonProps === void 0 ? void 0 : secondaryButtonProps.tooltip)
                ? {
                    tooltipProps: {
                        popperOptions: {
                            strategy: 'fixed',
                        },
                    },
                }
                : {}), secondaryButtonProps), void 0)),
            primaryButtonProps && (_jsx(PrimaryButton, __assign({ staticSize: staticSize }, ((primaryButtonProps === null || primaryButtonProps === void 0 ? void 0 : primaryButtonProps.tooltip)
                ? {
                    tooltipProps: {
                        popperOptions: {
                            strategy: 'fixed',
                        },
                    },
                }
                : {}), primaryButtonProps), void 0))] }), void 0));
};
export default ModalFooter;
var Footer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 18px 24px;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  box-sizing: border-box;\n"], ["\n  padding: 18px 24px;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  box-sizing: border-box;\n"])));
var CenteredButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0 auto;\n"], ["\n  margin: 0 auto;\n"])));
var SecondaryButton = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-right: 24px;\n"], ["\n  margin-right: 24px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
